// src/oura/newscan/useOpenScanDrafts.ts
//
// The open drafts of one kind, read once when a screen mounts, so a draft
// saved on Close can be picked up again without retyping its site.
//
// Null while the read runs or when it failed: the list then says nothing,
// which never claims that no draft is open.
//
// Only drafts with no purpose of their own are listed (JOURNEY-SPEC §1.1 row
// R): a signed client's First AI check (`purpose: "first_check"`) is reached
// from its onboarding line, never from the Drafts fold.

import { useEffect, useState } from "react";
import type { ScanDraftKind, ScanDraftListItem } from "@service/aeo/scanDraftTypes";
import { draftPurpose } from "@service/aeo/scanDraftTypes";
import { listOpenScanDrafts } from "@service/aeo/scanDraft";

export function useOpenScanDrafts(kind: ScanDraftKind, enabled = true): ScanDraftListItem[] | null {
    const [drafts, setDrafts] = useState<ScanDraftListItem[] | null>(null);
    useEffect(() => {
        setDrafts(null);
        if (!enabled) return;
        let cancelled = false;
        void listOpenScanDrafts().then((res) => {
            if (cancelled || !res.ok) return;
            setDrafts(res.data.filter((d) => d.kind === kind && draftPurpose(d) === d.kind));
        });
        return () => {
            cancelled = true;
        };
    }, [kind, enabled]);
    return drafts;
}
